<template>
    <td-dialog
        v-dialogDrag
        :title="$t(title)"
        :before-close="queueDialogClose"
        :visible.sync="dialogQueueVisible"
        width="680px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formQueueInfo" ref="formQueueInfo" label-width="100px" :rules="rules">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.QUEUE_NAME')" :label-width="formLabelWidth" prop="sChannelName">
                        <td-input v-model="formQueueInfo.sChannelName" :disabled="editFlag" maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.BELONGED_MQ')" :label-width="formLabelWidth" prop="sMqName">
                        <td-select v-model="formQueueInfo.sMqName" :disabled="editFlag" :options="optionsMq"></td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item :label="$t('common.TRANSFER_MODE')" :label-width="formLabelWidth" prop="iMode">
                        <td-select v-model="formQueueInfo.iMode" :disabled="editFlag" :options="optionsMode"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.PERSISTENCE')" :label-width="formLabelWidth">
                        <template>
                            <el-radio :disabled="editFlag" v-model="formQueueInfo.iDurable" label="1">{{ $t('common.YES') }}</el-radio>
                            <el-radio :disabled="editFlag" v-model="formQueueInfo.iDurable" label="0">{{ $t('common.NOT') }}</el-radio>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item :label="$t('common.IMESSAGETTL_TYPE')" :label-width="formLabelWidth" prop="iMessageTTLType">
                        <td-select v-model="formQueueInfo.iMessageTTLType" :options="optionsIMessageMode" @change="iMessageTypeChange"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="iMessageTTLFlag">
                    <el-form-item :label="$t('common.IMESSAGETTL')" :label-width="formLabelWidth" prop="iMessagettl">
                        <td-input-number v-model="formQueueInfo.iMessagettl" :min="1" :max="8640000" width="155"></td-input-number>
                        <span>{{ $t('common.IMESSAGE_SECONDS') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item :label="$t('common.MQ_CHANNEL_MAX_LENGTH')" :label-width="formLabelWidth" prop="iChannelMaxLength">
                        <td-inputNumber v-model="formQueueInfo.iChannelMaxLength" :disabled="editFlag" :min="1" :max="200000" width="150"></td-inputNumber>
                        <span>{{ $t('pgCommon.WAN') }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.I_PRIORITY')" :label-width="formLabelWidth">
                        <template>
                            <el-radio :disabled="editFlag" v-model="formQueueInfo.iPriority" label="1">{{ $t('common.START') }}</el-radio>
                            <el-radio :disabled="editFlag" v-model="formQueueInfo.iPriority" label="0">{{ $t('common.DISABLE') }}</el-radio>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.DESCRIPTION')" :label-width="formLabelWidthTex">
                        <td-input type="textarea" :rows="2" v-model="formQueueInfo.sDescription" style="width:100%;" :maxlength="500"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoding" @click="submitForm('formQueueInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="queueDialogClose" :disabled="cancelDisable">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import queueApi from '../assets/api.js';
export default {
    props: ['title', 'dialogQueueVisible', 'editItem', 'listMqInfo', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.editFlag = true;
            this.initEditData();
        } else {
            if (this.listMqInfo !== null && this.listMqInfo.length > 0) {
                this.formQueueInfo.sMqName = this.listMqInfo[0].value;
            }
        }
    },
    // 定义变量
    data() {
        return {
            editFlag: false,
            cancelDisable: false,
            // mq表单信息
            formQueueInfo: {
                sChannelName: '',
                sMqName: '',
                iMode: '0',
                iDurable: '0',
                sDescription: '',
                iMessagettl: 60,
                iMessageTTLType: '0',
                iChannelMaxLength: 10,
                iPriority: '0'
            },

            // 所属mq数组
            optionsMq: this.listMqInfo,

            optionsMode: [
                {
                    value: '0',
                    label: this.$t('common.WORKQUEUE')
                },
                {
                    value: '1',
                    label: this.$t('common.FANOUT')
                },
                {
                    value: '2',
                    label: this.$t('common.DIRECT')
                },
                {
                    value: '3',
                    label: this.$t('common.TOPIC')
                }
            ],
            iMessageTTLFlag: true,
            optionsIMessageMode: [
                {
                    value: '0',
                    label: this.$t('common.TEMPORARY')
                },
                {
                    value: '1',
                    label: this.$t('common.PERMANENT')
                }
            ],
            formLabelWidth: '35%',
            formLabelWidthTex: '17%',
            // 对表单进行数据验证
            rules: {
                sChannelName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.QUEUE_CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL_CHECK_NO_ZH') }
                ],
                sMqName: [{ required: true, message: this.$t('error.ERROR_INPUT_MQ'), trigger: 'change' }],
                iMode: [{ required: true, message: this.$t('error.ERROR_INPUT_TRANS_MODE'), trigger: 'change' }],
                iMessageTTLType: [{ required: true, message: this.$t('error.ERROR_INPUT_IMESSAGETTL'), trigger: 'change' }],
                iMessagettl: [{ required: true, message: this.$t('pgError.ERROR_INPUT_IMESSAGE_NUM'), trigger: 'change' }],
                iChannelMaxLength: [{ required: true, message: this.$t('error.ERROR_ICHANNEL_MAX_LENGTH_NULL'), trigger: 'blur' }]
            },
            saveLoding: false
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formQueueInfo.sChannelName = this.editItem.sChannelName;
            this.formQueueInfo.sMqName = this.editItem.sMqId;
            this.formQueueInfo.iMode = String(this.editItem.iMode);
            this.formQueueInfo.iDurable = String(this.editItem.iDurable);
            this.formQueueInfo.sDescription = this.editItem.sDescription;
            this.formQueueInfo.iPriority = String(this.editItem.iPriority);
            if (null === this.editItem.iMessagettl || this.editItem.iMessagettl === 0) {
                this.formQueueInfo.iMessageTTLType = '1';
                this.iMessageTTLFlag = false;
            } else {
                this.formQueueInfo.iMessageTTLType = '0';
                this.iMessageTTLFlag = true;
            }
            this.formQueueInfo.iMessagettl = this.editItem.iMessagettl;
            this.formQueueInfo.iChannelMaxLength = this.editItem.iChannelMaxLength / 10000;
        },
        iMessageTypeChange(value) {
            if (value === '0') {
                this.iMessageTTLFlag = true;
                if (this.formQueueInfo.iMessagettl === 0) {
                    this.formQueueInfo.iMessagettl = 60;
                }
            } else {
                this.iMessageTTLFlag = false;
            }
        },
        // 提交数据
        submitForm(formName) {
            if (this.formQueueInfo.iMessageTTLType === '1') {
                this.formQueueInfo.iMessagettl = 0;
            }
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoding = true;
                    this.cancelDisable = true;
                    let content = {
                        sChannelName: this.formQueueInfo.sChannelName,
                        sMqId: this.formQueueInfo.sMqName,
                        iMode: this.formQueueInfo.iMode,
                        iDurable: this.formQueueInfo.iDurable,
                        iPriority: this.formQueueInfo.iPriority,
                        sDescription: this.formQueueInfo.sDescription,
                        iMessagettl: this.formQueueInfo.iMessagettl,
                        iChannelMaxLength: this.formQueueInfo.iChannelMaxLength * 10000
                    };
                    if (this.isAddData) {
                        queueApi.addMqChannel(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                if (null != response.data.content) {
                                    var message = response.data.content.split('<br/>').join(';');
                                    this.$message({ showClose: true, message: message, type: 'error' });
                                    this.$log.error('dialogQueueInfo/addMqChannel', response.data.content);
                                } else {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('dialogQueueInfo/addMqChannel', response.data.statusMessage);
                                }
                                this.saveLoding = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.saveLoding = false;
                            this.queueDialogClose();
                            this.$emit('submit');
                        });
                    } else {
                        content.sid = this.editItem.sId;
                        queueApi.updateMqChannel(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                if (null != response.data.content) {
                                    var message = response.data.content.split('<br/>').join(';');
                                    this.$message({ showClose: true, message: message, type: 'error' });
                                    this.$log.error('dialogQueueInfo/updateMqChannel', response.data.content);
                                } else {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('dialogQueueInfo/updateMqChannel', response.data.statusMessage);
                                }
                                this.saveLoding = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.saveLoding = false;
                            this.queueDialogClose();
                            this.$emit('submit');
                        });
                    }
                }
            });
        },

        // 关闭窗口之前需要调用的方法
        queueDialogClose() {
            this.$emit('queueDialogClose');
            this.$refs['formQueueInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
